import { useAuth } from '@clerk/react';
import { useNavigate } from 'react-router-dom';
import {
  ActionIcon,
  Indicator
} from '@mantine/core';
import {
  IconBell
} from '@tabler/icons-react';
import { useLiveQuery, useSession } from '../../api';

// Header bell with the unread notification count (contract §4.11).
//
// - Renders nothing when signed out.
// - Only the envelope's unread_count is used, so limit: 1 keeps the payload
//   tiny; the notifications topic keeps the count live.
// - Clicking navigates to the /notifications inbox.
const NotificationBell = () => {
  const { isSignedIn } = useAuth();
  const { me } = useSession();
  const navigate = useNavigate();

  const { data } = useLiveQuery(
    '/api/v1/me/notifications',
    { page: 1, limit: 1 },
    {
      enabled: !!isSignedIn,
      topics: [me && `user.${me.clerk_user_id}.notifications`],
    }
  );

  if (!isSignedIn) return null;

  const unreadCount = data?.unread_count ?? 0;

  return (
    <Indicator
      label={unreadCount > 9 ? '9+' : unreadCount}
      size={16}
      disabled={unreadCount === 0}
      color="red"
      withBorder
    >
      <ActionIcon
        variant="subtle"
        size="lg"
        onClick={() => navigate('/notifications')}
        aria-label="Notifications"
        title={`Notifications (${unreadCount} unread)`}
      >
        <IconBell size="1.3rem" />
      </ActionIcon>
    </Indicator>
  );
};

export default NotificationBell;
